export default "__VITE_PUBLIC_ASSET__f8f7881b__"